import React from 'react';
import {AuthProvider} from '../context/auth'
import {UserProvider} from '../context/user'
import {SocketProvider} from '../context/socket'
import {ToastProvider} from 'react-toast-notifications'

const AppProviders = ({children}) => {
  return (
    <AuthProvider>
      <UserProvider>
        <SocketProvider>
          <ToastProvider>
            {children}
          </ToastProvider>
        </SocketProvider>
      </UserProvider>
    </AuthProvider>
  )
}

export default AppProviders
